import { AiIconSmall } from '@product-framework/components/ArtificalIntelligence/AiIcon';
import permissionConfig from './permissionConfig';

const menu = ({ navigate, userAccess, store, IconLibrary, moduleSettings }) => {
  const menuItems = [
    {
      name: 'Jobs',
      id: 'JOBS',
      hasPermission: true,
      Icon: IconLibrary.ServiceJobs,
      children: [
        {
          name: 'Create Job',
          hasPermission: permissionConfig({
            userAccess,
            permissionName: 'CREATE_JOB',
          }),
          tags: ['create', 'new', 'service', 'job', 'pre', 'register'],
          onClick: () => {
            navigate('/servicejobs/preregister');
          },
        },
        {
          name: 'List All Jobs',
          hasPermission: true,
          tags: ['list', 'all', 'service', 'job'],
          onClick: () => {
            store.domain.list.reset('ServiceJobList');
            navigate('/servicejobs');
          },
        },
        {
          name: 'Search Jobs',
          hasPermission: true,
          tags: ['list', 'all', 'service', 'job', 'search'],
          onClick: () => {
            navigate('/servicejobs?view=search');
          },
        },
      ],
    },
    {
      name: 'Management',
      id: 'MANAGEMENGT',
      hasPermission: true,
      Icon: IconLibrary.ServiceProviders,
      children: [
        {
          name: 'Service Providers',
          hasPermission: userAccess.isSA() || userAccess.isAdmin(),
          tags: [
            'list',
            'all',
            'serviceprovider',
            'serviceproviders',
            'manage',
          ],
          onClick: () => {
            navigate('/serviceproviders');
          },
        },
        {
          name: 'Users',
          hasPermission: true,
          tags: ['user', 'role', 'account'],
          onClick: () => {
            if (userAccess.isSA() || userAccess.isAdmin()) {
              navigate('/users');
            } else {
              const serviceProviderId = userAccess.company.id;
              // TODO: try removing hack, importing from config, causes dependency cycle
              const usersTabNumber = 2;
              navigate(
                `/serviceproviders/edit/${serviceProviderId}/${usersTabNumber}`,
              );
            }
          },
        },
        {
          name: 'Help & Training',
          hasPermission: true,
          tags: ['Help'],
          onClick: () => {
            navigate('/help');
          },
        },
        {
          name: 'API Documentation',
          hasPermission: true,
          tags: ['Documentation'],
          onClick: () => {
            navigate('/docs');
          },
        },
      ],
    },
  ];

  if (moduleSettings?.serviceDirectoryPurchased) {
    menuItems[1].children.push({
      name: 'Service Directory',
      hasPermission: userAccess.isSA() || userAccess.isAdmin(),
      tags: ['Documentation'],
      onClick: () => {
        navigate('/service-directory');
      },
    });
  }

  return menuItems;
};

const setup = ({ navigate, userAccess, IconLibrary }) => [
  {
    name: 'Setup',
    hasPermission: userAccess.isSA() || userAccess.isAdmin(),
    Icon: IconLibrary.Companies,
    children: [
      {
        name: 'Industries',
        hasPermission: true,
        tags: ['list', 'all', 'industry', 'manage'],
        onClick: () => {
          navigate('/industries');
        },
      },
      {
        name: 'Clients',
        hasPermission: true,
        tags: [
          'list',
          'all',
          'serviceadministratorclient',
          'serviceadministratorclients',
          'manage',
          'client',
          'administrator',
        ],
        onClick: () => {
          navigate('/serviceadministratorclients');
        },
      },
      {
        name: 'Product Lines',
        hasPermission: true,
        tags: [
          'list',
          'all',
          'serviceadministratorproductline',
          'serviceadministratorproductlines',
          'manage',
        ],
        onClick: () => {
          navigate('/serviceadministratorproductlines');
        },
      },
      {
        name: 'Repair Severities',
        hasPermission: true,
        tags: [
          'list',
          'all',
          'serviceadministratorrepairseverity',
          'serviceadministratorrepairseverities',
          'manage',
        ],
        onClick: () => {
          navigate('/serviceadministratorrepaircategories');
        },
      },
      {
        name: 'Service Types',
        hasPermission: true,
        tags: [
          'list',
          'all',
          'serviceadministratorservicetype',
          'serviceadministratorservicetypes',
          'manage',
        ],
        onClick: () => {
          navigate('/serviceadministratorservicetypes');
        },
      },
      {
        name: 'Warranty Types',
        hasPermission: true,
        tags: [
          'list',
          'all',
          'serviceadministratorwarrantytype',
          'serviceadministratorwarrantytypes',
          'manage',
        ],
        onClick: () => {
          navigate('/serviceadministratorwarrantytypes');
        },
      },
      {
        name: 'Service Sites',
        hasPermission: true,
        tags: ['list', 'all', 'servicesite', 'servicesites', 'manage'],
        onClick: () => {
          navigate('/servicesites');
        },
      },
      {
        name: 'Labor Matrix',
        hasPermission: true,
        tags: ['list', 'all', 'labor', 'labor matrix', 'manage'],
        onClick: () => {
          navigate('/labormatrices');
        },
      },
      {
        name: 'Brands',
        hasPermission: true,
        tags: ['list', 'all', 'brand', 'manage'],
        onClick: () => {
          navigate('/brands');
        },
      },
    ],
  },
  {
    name: 'System Settings',
    hasPermission:
      userAccess.isSASupervisor() || userAccess.isAdminImplementationManager(),
    Icon: IconLibrary.System,
    children: [
      {
        name: 'Countries',
        hasPermission:
          userAccess.isSASupervisor() ||
          userAccess.isAdminImplementationManager(),
        tags: ['list', 'all', 'country', 'countries', 'manage'],
        onClick: () => {
          navigate('/countries');
        },
      },
      {
        name: 'Job Forms',
        hasPermission:
          userAccess.isSASupervisor() ||
          userAccess.isAdminImplementationManager(),
        tags: ['list', 'all', 'jobform', 'jobforms', 'manage'],
        onClick: () => {
          navigate('/servicejobforms');
        },
      },
      {
        name: 'Rules',
        hasPermission:
          userAccess.isSASupervisor() ||
          userAccess.isAdminImplementationManager(),
        tags: ['list', 'all', 'rule', 'rules', 'manage'],
        onClick: () => {
          navigate('/rules');
        },
      },
      {
        name: 'Workflows',
        hasPermission:
          userAccess.isSASupervisor() ||
          userAccess.isAdminImplementationManager(),
        tags: ['list', 'all', 'workflow', 'workflows', 'manage'],
        onClick: () => {
          navigate('/workflows');
        },
      },
    ],
  },
  {
    name: 'Insights',
    hasPermission:
      userAccess.isSASupervisor() || userAccess.isAdminImplementationManager(),
    Icon: AiIconSmall,
    children: [
      {
        name: 'Flow Definitions',
        hasPermission: true,
        tags: ['list', 'all', 'flow', 'definitions', 'manage'],
        onClick: () => {
          navigate('/flow-definitions');
        },
      },
      {
        name: 'Insight Config',
        hasPermission: true,
        tags: ['list', 'all', 'insight', 'config', 'manage'],
        onClick: () => {
          navigate('/insight-config');
        },
      },
      {
        name: 'Managed Numbers',
        hasPermission: true,
        tags: ['list', 'all', 'managed', 'number', 'phone', 'manage'],
        onClick: () => {
          navigate('/managed-numbers');
        },
      },
    ],
  },
];

export default { menu, setup };
